import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CONSTANTS } from '../constants/constants';
import { indexedDBJSONStorage } from './indexedDBStorage';

export const useThemeStore = create(
  persist(
    (set, get) => ({
      // State
      currentTheme: CONSTANTS.STANDARD_THEME,

      // Actions
      setTheme: (theme) => {
        // Update body class
        document.body.classList.remove(CONSTANTS.STANDARD_THEME, CONSTANTS.DARK_THEME);
        document.body.classList.add(theme);

        set({ currentTheme: theme });
      },
      
      toggleTheme: () => {
        const { currentTheme } = get();
        const newTheme = currentTheme === CONSTANTS.STANDARD_THEME ? CONSTANTS.DARK_THEME : CONSTANTS.STANDARD_THEME;
        
        // Update body class
        document.body.classList.remove(CONSTANTS.STANDARD_THEME, CONSTANTS.DARK_THEME);
        document.body.classList.add(newTheme);
        
        set({ currentTheme: newTheme });
      },
      
      initializeTheme: () => {
        const { currentTheme } = get();
        document.body.classList.add(currentTheme);
      }
    }),
    {
      name: CONSTANTS.LOCAL_STORAGE_THEME_KEY,
      storage: indexedDBJSONStorage
    }
  )
);